import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

const fmt = (n) => n.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });

export const Calculator = ({ onQualify }) => {
  const [loan, setLoan] = useState(400000);
  const credit = Math.round(loan * 0.01);
  const fill = `${((loan - 150000) / 700000) * 100}%`;

  return (
    <section id="savings" data-testid="savings-section" className="relative overflow-hidden bg-[#FAF8F5] py-28 sm:py-36">
      <div className="mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-2 lg:items-center">
        <Reveal>
          <p data-testid="savings-eyebrow" className="font-mono text-xs font-bold uppercase tracking-[0.3em] text-[#D97706]">
            Chapter 01 — The Offer
          </p>
          <h2 className="mt-4 font-display text-2xl font-bold tracking-tight text-[#0B162C] sm:text-3xl lg:text-4xl">
            One percent says
            <br />
            thank you.
          </h2>
          <p className="mt-6 max-w-md text-base leading-relaxed text-slate-600 sm:text-lg">
            The Georgia Local Heroes Program provides eligible borrowers a{" "}
            <strong className="text-[#0B162C]">1% lender credit*</strong> toward qualifying closing costs when purchasing or
            refinancing a home — based on the loan amount.
          </p>
          <p className="mt-4 max-w-md text-sm italic leading-relaxed text-slate-500">
            It's our way of saying thank you to the individuals who make a difference in our communities every day.
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div
            data-testid="savings-calculator"
            className="relative overflow-hidden rounded-3xl bg-[#0B162C] p-8 shadow-[0_30px_80px_rgba(11,22,44,0.35)] sm:p-10"
          >
            <div className="grain-overlay" />
            <p className="font-mono text-[11px] font-bold uppercase tracking-[0.25em] text-[#FEF3C7]/60">Estimated Loan Amount</p>
            <p data-testid="calc-loan-value" className="mt-2 font-display text-3xl font-bold text-[#FAF8F5]">
              {fmt(loan)}
            </p>
            <input
              type="range"
              min={150000}
              max={850000}
              step={5000}
              value={loan}
              onChange={(e) => setLoan(Number(e.target.value))}
              className="hero-range mt-6 w-full"
              style={{ "--fill": fill }}
              data-testid="calc-slider"
              aria-label="Estimated loan amount"
            />
            <div className="mt-2 flex justify-between font-mono text-[10px] font-bold text-[#FEF3C7]/50">
              <span>$150K</span>
              <span>$850K</span>
            </div>
            <div className="my-8 h-px bg-gradient-to-r from-transparent via-[#F59E0B]/40 to-transparent" />
            <p className="font-mono text-[11px] font-bold uppercase tracking-[0.25em] text-[#FEF3C7]/60">Your 1% Lender Credit*</p>
            <p data-testid="calc-output" className="mt-2 font-display text-5xl font-black text-[#F59E0B]">
              {fmt(credit)}
            </p>
            <p className="mt-3 text-xs leading-relaxed text-[#FEF3C7]/60">
              Toward qualifying closing costs. Most FHA, VA and conventional loan programs; may not be combined with other loan programs. Credit cannot exceed actual closing costs; no cash
              back.
            </p>
            <button
              data-testid="calc-qualify-btn"
              onClick={onQualify}
              className="group mt-8 flex w-full items-center justify-center gap-2 rounded-full bg-[#DC2626] py-4 font-mono text-xs font-bold uppercase tracking-[0.2em] text-white transition-[background-color,box-shadow] duration-300 hover:bg-[#B91C1C] hover:shadow-[0_10px_30px_rgba(220,38,38,0.45)]"
            >
              Claim My Credit
              <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
